import React, { useState, Fragment, useEffect } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { Modal } from "react-bootstrap";
import LinkButton from "../../utils/LinkButton";

import "../../static/css/jobsStyle.css";
import useOnceEffect from "../../Hooks/useOnceEffect";
import useToggle from "../../Hooks/useToggle";
import CustomSwitch from "../../utils/Switch/Switch";

function EstadoVacantes({ data }) {
  const [listVacantes, setlistVacantes] = useState([]);
  const [vacanteId, setVacantId] = useState(null)
  const [modal, toggleModal] = useToggle(false)
  const [showActiveVacant, setShowActiveVacant] = useState(true);

  useOnceEffect(() => {
    GetVacantes();
    SetTabActive();
  });

  function GetVacantes() {
    axios
      .get("company-vacant/list-vacants/" + data.companyProfileId)
      .then((result) => {
        setlistVacantes(result.data);
      });
      
  }

  function SetTab() {
    document.getElementById("pills-tab3").setAttribute("class", "nav-link");
    document
      .getElementById("pills-tab1")
      .setAttribute("class", "nav-link active");
  }

  function CerrarVacante(body = {}) {

    axios
      .post(`company-vacant/close/${vacanteId}`, body)
      .then((result) => {
        if (result.status === 200) {
          toast.success(result.data.message, {
            duration: 4000,
          });
          GetVacantes();
        }
      })
      .finally(() => toggleModal())
  }

  function SetTabActive() {
    document
      .getElementById("pills-tab3")
      .setAttribute("class", "nav-link active");

    document.getElementById("pills-tab1").setAttribute("class", "nav-link");
  }

  return (
    <Fragment>
      <div className="content" style={{ width: "100%" }}>
        <div className="row mt-5">
          
          <section className="d-flex justify-content-between align-items-center">
            <h5>Vacantes y Pasantías Publicadas</h5>

            
            <CustomSwitch label="Vacantes activas" onchange={setShowActiveVacant} />
          </section>
          
          <hr />
          <p className="mt-4">Personaliza el estado de vacante</p>


          

          <br />
          <br />

          { showActiveVacant  && <Vacantes {...{listVacantes, SetTab, toggleModal, setVacantId}} /> }
          { !showActiveVacant && <VacantesCerradas companyId={data?.companyProfileId} /> }

        </div>
      </div>

      <CerrarVacanteModal show={modal} onHide={toggleModal} CerrarVacante={CerrarVacante} vacantId={vacanteId} />

    </Fragment>
  );
}


function Vacantes({listVacantes = [], SetTab, toggleModal, setVacantId}) {


  if(listVacantes.length === 0) {
    return <h2 className="text-center">No hay Vacantes Abiertas todavía</h2>
  }

  return listVacantes.map((item, index) => (
      <div key={index} className="col-md-12">
        <div className="steps-box mb-4">
          <div className="row">
            <div className="col-md-6">
              <p className="tit">{item.companyDTOResponse.cargo}</p>
            </div>
            <div className="col-md-6 text-end">
              <p className="sub-tit">
                Fecha de Publicación:{" "}
                <span>{item.companyDTOResponse.fechaPublicacion}</span>
              </p>
              <p className="sub-tit">
                Estado:{" "}
                <span>
                  {item.companyDTOResponse.esVigente
                    ? "Activo"
                    : "Cerrada"}
                </span>
              </p>
            </div>
          </div>
          <div className="process-wrapper mb-3">
            <div id="progress-bar-container">
              <ul>
                {item.etapasVacante.map((item, index) => {
                  return (
                    <li
                      key={index}
                      className={
                        item.completado
                          ? "step stepA" + item.orden + " active"
                          : "step stepA" + item.orden
                      }
                    >
                      <div className="step-inner">
                        {item.nombreEtapa}
                      </div>
                    </li>
                  );
                })}
              </ul>
              <div id="line">
                <div id="line-progress"></div>
              </div>
            </div>
          </div>
          <div className="row mt-3 justify-content-end">
            <LinkButton
              to={{
                pathname: "/company/Vacante/Publica",
                state: {
                  vacantId: item.companyDTOResponse.companyVacantId,
                },
              }}
              onClick={SetTab}
              type="button"
              className="btn btn-infome-4 btn btn-light"
              style={{ marginRight: "24px", borderRadius: "30px" }}
            >
              Editar
            </LinkButton>

            <button
              className="me-4 btn btn-light"
              onClick={() => {
                toggleModal()
                setVacantId(item.companyDTOResponse.companyVacantId)
              }}
              style={{ borderRadius: "30px" }}
            >
              Cerrar Vacante
            </button>

            <LinkButton
              to={{
                pathname: "/company/Vacante/Candidatos",
                state: {
                  vacante: item.companyDTOResponse,
                  etapas: item.etapasVacante,
                },
              }}
              type="button"
              className="btn btn-info"
              style={{ height: "50px", width: "auto" }}
            >
              Ver Candidatos
            </LinkButton>
          </div>

        </div>
      </div>
  ))
}

export function VacantesCerradas({companyId, render = null}) {

  const  [listClosed, setListClosed] = useState([])

  useEffect(() =>{

    if(companyId) {
      axios
        .get(`company-vacant/list-closed-vacants/${companyId}`)
        .then(({data}) => setListClosed(data));
    }
    
  }, [companyId])

  if(listClosed.length === 0) {
    return <h2 className="text-center">No hay Vacantes cerradas todavía</h2>
  }

  if(render !== null) {
    return render(listClosed, CloseReason);
  }

  function CloseReason(vacant) {

    if(vacant.closereason.note === null && vacant.selected === null) {
      return <li>Selección Externa Krezco</li>
    }

    if(vacant.closereason.note !== null) {
      return [
        <li>Vacante Desierta</li>,
        <li>Nota: {vacant.closereason.note}</li>
      ]
    }

    if(vacant.selected !== null) {
      return [
        <li>Selección Interna Krezco</li>,
        <li>Aplicante : {vacant.selected}</li>
      ]
    }
  }

  
  return listClosed.map((item, index) => (
    <div key={index} className="col-md-12">
      <div className="steps-box mb-4">
        <div className="row">
          <div className="col-md-6">
            <p className="tit">{item.companyDTOResponse.cargo}</p>
          </div>
          <div className="col-md-6 text-end">
            <p className="sub-tit">
              Fecha de Publicación:{" "}
              <span>{item.companyDTOResponse.fechaPublicacion}</span>
            </p>
            <p className="sub-tit">
              Estado:{" "}
              <span>
                {item.companyDTOResponse.esVigente
                  ? "Activo"
                  : "Cerrada"}
              </span>
            </p>
          </div>
        </div>
        <div className="process-wrapper mb-3">
          <div id="progress-bar-container">
            <ul>
              {item.etapasVacante.map((item, index) => {
                return (
                  <li
                    key={index}
                    className={
                      item.completado
                        ? "step stepA" + item.orden + " active"
                        : "step stepA" + item.orden
                    }
                  >
                    <div className="step-inner">
                      {item.nombreEtapa}
                    </div>
                  </li>
                );
              })}
            </ul>
            <div id="line">
              <div id="line-progress"></div>
            </div>
          </div>
        </div>

        { item.companyDTOResponse.closereason && (
          <div>
            Motivo de cierre: 
              <ul style={{height: "unset", boxShadow: "none"}}>
                { CloseReason(item.companyDTOResponse) }
              </ul>
          </div>
        )}
        

      </div>
    </div>
  ))

}

export function CerrarVacanteModal({ CerrarVacante, vacantId, show, onHide }) {

  const [candidatos, setCandidatos] = useState([])
  const [motivo, setMotivo] = useState(0);

  const [data, setData] = useState({
    applicantProfile: null,
    nota: null
  })

  useEffect(() => {

    if(vacantId === null) {
      return;
    }

    axios
      .get(`company-vacant/list-details-vacants/${vacantId}`)
      .then(({data}) => setCandidatos(data) )



  }, [vacantId])

  function localClose() {
    
    let post = {...data}

    switch (motivo) {
      case 1:
        if(post.applicantProfile === null) {
          toast.error("Escoja un aplicante")
          return
        }else {
          setData({...data, nota: null})
          post.nota = null
        }
        
        break;
  
      case 2:
        setData({applicantProfile: null, nota: null})
        post.applicantProfile = null
        post.nota = null 
        break

      case 3: 
        if(post.nota === null) {
          toast.error("Agregue una nota")
          return
        }else {
          setData({...data, applicantProfile: null})
          post.applicantProfile = null
        }
        break
      default:
        break;
    }

    CerrarVacante(post)

  }

  return (
    <>
      <Modal show={show} onHide={onHide} className="kr-modal">
        <Modal.Header></Modal.Header>

        <Modal.Body>
          <div className="form form--white">
            <div className="div__wrapper">
              <div className="form__title text-center">
                ¿Estas seguro que deseas cerrar la Vacante?
              </div>

              <section>
                <p>Seleccione el motivo de cierre</p>

                <div className="form-group">
                  <select defaultValue="0" className="form-control" onChange={({target}) => setMotivo(parseInt(target.value))} >
                    <option value={0} hidden>Seleccione un motivo de cierre</option>
                    <option value={1}>Selección Interna krezco</option>
                    <option value={2}>Selección Externa krezco</option>
                    <option value={3}>Desierta</option>
                  </select>
                </div>

                { motivo === 1 &&
                  <div className="form-group">
                    <label>Seleccione un aplicante</label>
                    <select defaultValue="0" onChange={({target}) => setData({...data, applicantProfile: parseInt(target.value)})} className="form-control">
                      <option value={0}>Escoja un candidato</option>
                      { candidatos.map((elm, i) => <option key={i} value={elm.profile.applicantProfileId}>{elm.names} {elm.lastnames}</option>) }
                    </select>
                  </div>
                }

                { motivo === 3 &&
                  <div className="form-group">
                    <label>Agrege una nota al cierre de la vacante</label>
                    <textarea value={data.nota ?? ""} onChange={({target}) => setData({...data, nota: target.value})} className="form-cotnrol" rows={3} maxLength={255}  />
                  </div>
                }


                { motivo !== 0 &&
                  <div className="d-flex">
                      <button className="btn-deg mx-2" onClick={onHide} style={{background: "grey"}}>Cancelar</button>
                      <button className="btn-deg mx-2" onClick={localClose}>Cerrar Vacante</button>
                  </div>
                }

              </section>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default EstadoVacantes;
